import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {PodcastItem} from "../editor/podcast-item";
import {FileUploadComponent} from "../core/file-upload/file-upload.component";
import { HttpClient } from '@angular/common/http';
import {Router, ActivatedRoute} from "@angular/router";


import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalComponent} from "../core/modals/modal/modal.component";

import { environment } from '../../environments/environment';
import {User} from "../core/user";
import {ImageItem} from "../editor/image-item";
import {TextItem} from "../editor/text-item/text-item";
import {PlayerPoint} from "../editor/player/point";
import {TranslationService} from "../services/translation.service";

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss']
})
export class UploaderComponent implements OnInit {

    uploadWaitStatus: boolean;
    podcastItem: PodcastItem;
    apiEndpointPath:string = environment.uploadFilesPath;
    maxFileCount: number = 30;
    allowedFileExtension: string = 'jpg,gif,png,mp3';
    maxFileSize: number = 1024*120;
    modalRef: BsModalRef;

    @ViewChild(FileUploadComponent)
    private fileUploadComponent: FileUploadComponent;


  constructor(
      private http: HttpClient,
      private router: Router,
      private route: ActivatedRoute,
      private modalService: BsModalService,
      private translateService: TranslationService
  ) { }

  ngOnInit() {
    this.podcastItem = new PodcastItem();

      this.route.params.subscribe(params => {
          if(params['id']){
              const podcastId = +params['id'];

              const data =
                  this.http
                      .get('/editor/get?id=' + params['id'] ).subscribe( (result:any) => {
                      let i = 1;

                      let existUrls = {};

                      this.podcastItem.id = result.id ? result.id : null;
                      this.podcastItem.name = result.name;
                      this.podcastItem.description = result.description;
                      this.podcastItem.tags = result.tags;
                      this.podcastItem.textBody = result.initialText;
                      this.podcastItem.podcastAudio = result.audio;

                      this.podcastItem.secret = result.secret;

                      this.podcastItem.is_my = result.is_my;
                      this.podcastItem.is_public = result.is_public;

                      result.images.forEach( (imgUrl) => {
                          let img = new ImageItem();
                          img.url = imgUrl;
                          this.podcastItem.podcastImages.push(img);
                      });


                  }, (error:any) => {
                      const initialState = {
                          title: 'Error',
                          type: 'danger',
                          text: error.error.message
                      };

                      this.modalRef = this.modalService.show(ModalComponent, {initialState});
                  })
          }
      });
  }

  create(podcastEditForm) {
    if(!podcastEditForm.form.valid){
      this._handleError(this.translateService.translate('uploader-error-4'))
      return;
    }

    if(!this.podcastItem.id && this.maxFileCount-this.fileUploadComponent.fileUploaderInstance.getRemainingAllowedItems() < 2){
        this._handleError(this.translateService.translate('uploader-error-3'))
      return;
    }

    this.uploadWaitStatus = true;

    this.http.post( environment.apiEndpoint+environment.podcastCreatePath, this.podcastItem).subscribe( (podcastItem:PodcastItem) => {
      this.podcastItem.id = podcastItem.id;

      if(this.fileUploadComponent.fileUploaderInstance.getRemainingAllowedItems() != this.maxFileCount){
          this.fileUploadComponent.fileUploaderInstance.setCustomHeaders({PodcastId: podcastItem.id});
          this.fileUploadComponent.fileUploaderInstance.uploadStoredFiles();
      }else{
          this.router.navigate(['editor/edit/' + this.podcastItem.id]);
      }
    }, (error) => {
        this._handleError(error.error.message);
    });
  }

  allFileUploaded(e) {

    if(e.failed.length == 0 && this.podcastItem.podcastAudio) {
        this.router.navigate(['editor/edit/' + this.podcastItem.id])
    }else if (e.failed.length == 0 && !this.podcastItem.podcastAudio ) {
        this._handleError( this.translateService.translate('uploader-error-1'))
    }else{
        this._handleError(this.translateService.translate('uploader-error-2'))
    }
  }

  fileUploaded(e) {
      if(e.params.data.type == 'audio/mp3'){
          this.podcastItem.podcastAudio=e.params.data.filename;
      }
  }

  _handleError(error) {
    const initialState = {
        title: 'Error!',
        type: 'danger',
        text: error
    };
    this.modalRef = this.modalService.show(ModalComponent, {initialState});
  }
}
